// extracted by mini-css-extract-plugin
export default {"dropArea":"DropArea_dropArea__KcFRS","dragOver":"DropArea_dragOver__NZfJT"};